import React, { useEffect, useState } from 'react';
import { pagesDuSiteService, PageDuSite } from '../../services/pagesDuSiteService';
import ContentSkeleton from '../Skeleton/ContentSkeleton';
import './PageStatique.css';

interface Props {
    slug: string;
    onDateLoaded?: (date: string | null) => void;
}

const PageStatique: React.FC<Props> = ({ slug, onDateLoaded }) => {
    const [page, setPage] = useState<PageDuSite | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setLoading(true);
        setError(null);
        pagesDuSiteService
            .getPage(slug)
            .then((p) => {
                setPage(p);
                if (onDateLoaded) {
                    const date = p.updated_at
                        ? new Date(p.updated_at).toLocaleDateString('fr-FR', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                        })
                        : null;
                    onDateLoaded(date);
                }
            })
            .catch(() => {
                setError('Contenu momentanément indisponible.');
                if (onDateLoaded) onDateLoaded(null);
            })
            .finally(() => setLoading(false));
    }, [slug]);

    if (loading) {
        return (
            <div className="page-statique">
                <ContentSkeleton variant="richtext" />
            </div>
        );
    }

    if (error || !page) {
        return <div className="page-statique-error">{error || 'Page introuvable.'}</div>;
    }

    return (
        <div className="page-statique">
            {page.contenu ? (
                <div
                    className="page-statique-contenu"
                    dangerouslySetInnerHTML={{ __html: page.contenu }}
                />
            ) : (
                <p className="page-statique-vide">Contenu en cours de rédaction.</p>
            )}
        </div>
    );
};

export default PageStatique;
